import FeatureConfigCard from '@/components/admin/common/FeatureConfigCard';
import EffectiveFeatureConfigCard from '@/components/admin/common/EffectiveFeatureConfigCard';
import type { User } from '@/models';

interface UserDetailPageTabFeaturesProps {
  user: User;
  onUserUpdated: (user: User) => void;
}

export default function UserDetailPageTabFeatures({ user, onUserUpdated }: UserDetailPageTabFeaturesProps) {
  return (
    <div className="space-y-8">
      {/* Manual Feature Configuration */}
      <FeatureConfigCard user={user} onUserUpdated={onUserUpdated} />

      {/* Effective Feature Configuration */}
      <EffectiveFeatureConfigCard featureConfig={user.featureConfig} />
    </div>
  );
}
